import { all, call, fork, takeLatest, takeEvery } from "redux-saga/effects";

import { Types as BannersTypes } from "../ducks/banners";
import { Types as ProductsTypes } from "../ducks/products";
import { Types as CartTypes } from "../ducks/cart";
import { Types as AuthTypes } from "../ducks/auth";
import { Types as SignUpTypes } from "../ducks/signup";
import { Types as SearchProductsTypes } from "../ducks/search";
import { Types as PasswordTypes } from "../ducks/password";
import { Types as SuggestTypes } from "../ducks/suggest";
import { Types as CategoryTypes } from "../ducks/category";
import { Types as StoreTypes } from "../ducks/store";
import { Types as AddressTypes } from "../ducks/address";
import { Types as OrderTypes } from "../ducks/order";
import { Types as MyOrdersTypes } from "../ducks/myOrders";
import { Types as StoreByUserTypes } from "../ducks/storeByUser";
import { Types as DomainTypes } from "../ducks/domain";
import { Types as CouponTypes } from "../ducks/coupon";
import { Types as IdentidadeVisualTypes } from "../ducks/identidadeVisual";
import { Types as DeliveryContextTypes } from "../ducks/deliveryContext";

import { getBanners, getBannersProducts, getHighlights } from "./banners";
import { getMyOrdersRequest, getMyOrderByIdRequest } from "./myOrders";
import { updateUser, getAccount, removeUser } from "./user";
import { finishOrder, createPixPayment } from "./order";
import {
  getProducts,
  getProductBySlug,
  getNewsProduct,
  getProductNotifyStock,
  removeNotification,
  addProductNotifyStock
} from "./products";
import { getProductsBySearchTerm } from "./search";
import { getSuggestions, clearSuggestions } from "./suggest";
import { signUp } from "./signup";
import {
  recoverPassword,
  newPassword,
  verifyToken,
  updatePassword
} from "./password";

import {
  addProductBasket,
  setCartInState,
  removeProductCart,
  setOrderStorage,
  reorganizeBasket,
  checkOutOfStockProductsByStore,
  deleteOutOfStockItemsFromCart,
  removeProductsFromCart,
  getProductListRequest,
  addProductListBasket,
  syncCartState
} from "./cart";

import { signOut, signIn, signInSuccess, requestAccessCode, verifyAccessCode } from "./auth";
import { getStore } from "./store";
import { addressStore, addressUpdate, getAddresses } from "./address";
import { UserTypes } from "../ducks/user";
import { getStoreByDomain } from "./domain";
import { getCoupon } from "./coupon";
import { getCategories } from "./category";
import analyticsSaga from "../analytics/saga";
import { fetchIdentidadeVisual } from "./identidadeVisual";
import { persistSelectedStore } from "./storeByUser";
import {
  hydrate as hydrateDeliveryContext,
  applyLocation,
  resolveCoverage,
  onLockedPharmacyChanged,
  onAddressRemoved,
  inheritInitialAddress,
  watchStorageSync,
  watchAddressUpdate
} from "./deliveryContext";


export default function* rootSaga() {
  yield all([
    takeLatest(BannersTypes.GET_REQUEST, getBanners),
    takeLatest(BannersTypes.GET_HIGHLIGHTS_REQUEST, getHighlights),
    takeLatest(ProductsTypes.GET_REQUEST, getProducts),
    takeLatest(ProductsTypes.GET_REQUEST_NEW_PRODUCTS, getNewsProduct),
    takeLatest(ProductsTypes.GET_ALREADY_REQUESTED_PRODUCTS, getNewsProduct),
    takeLatest(ProductsTypes.SHOW_REQUEST, getProductBySlug),
    takeLatest(ProductsTypes.GET_REQUESTED_NOTIFY_PRODUCT_STOCK, getProductNotifyStock),
    takeLatest(ProductsTypes.REMOVE_REQUESTED_NOTIFY_PRODUCT_STOCK, removeNotification),
    takeLatest(ProductsTypes.ADD_REQUESTED_NOTIFY_PRODUCT_STOCK, addProductNotifyStock),
    takeLatest(SearchProductsTypes.SEARCH_PRODUCTS_REQUEST, getProductsBySearchTerm),
    takeLatest(SearchProductsTypes.LOAD_MORE_REQUEST, getProductsBySearchTerm),
    takeLatest(SearchProductsTypes.SET_FILTER_TERMS, getProductsBySearchTerm),
    takeLatest(SearchProductsTypes.SET_SEARCH_TERM, getSuggestions),
    takeEvery(SearchProductsTypes.SEARCH_PRODUCTS_SUCCESS, clearSuggestions),
    takeLatest(SuggestTypes.GET_REQUEST, getSuggestions),
    takeLatest(CartTypes.ADD_PRODUCT, addProductBasket),
    takeLatest(CartTypes.ADD_PRODUCT_LIST, addProductListBasket),
    takeLatest(CartTypes.REMOVE_PRODUCT, removeProductCart),
    takeLatest(CartTypes.GET_STORAGE_CART, setCartInState),
    takeLatest(CartTypes.SET_ORDER_STORAGE, setOrderStorage),
    takeLatest(CartTypes.GET_SELECTED_REQUEST, getProductListRequest),
    takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn),
    takeLatest(AuthTypes.ACCESS_CODE_REQUEST, requestAccessCode),
    takeLatest(AuthTypes.ACCESS_CODE_VERIFY_REQUEST, verifyAccessCode),
    takeLatest(AuthTypes.SIGN_OUT, signOut),
    takeLatest(UserTypes.UPDATE_REWARDS_PROGRAM, reorganizeBasket),
    takeLatest(SignUpTypes.SIGN_UP_REQUEST, signUp),
    takeLatest(PasswordTypes.RECOVER_PASSWORD_REQUEST, recoverPassword),
    takeLatest(PasswordTypes.NEW_PASSWORD_REQUEST, newPassword),
    takeLatest(PasswordTypes.VERIFY_TOKEN_REQUEST, verifyToken),
    takeLatest(AddressTypes.ADDRESS_REQUEST, addressStore),
    takeLatest(AddressTypes.ADDRESS_UPDATE_REQUEST, addressUpdate),
    takeLatest(StoreTypes.GET_REQUEST, getStore),
    takeLatest(OrderTypes.ORDER_REQUEST, finishOrder),
    takeLatest(MyOrdersTypes.GET_REQUEST, getMyOrdersRequest),
    takeLatest(MyOrdersTypes.GET_ORDER_BY_ID, getMyOrderByIdRequest),
    takeLatest(UserTypes.UPDATE_USER_REQUEST, updateUser),
    takeLatest(UserTypes.REMOVE_USER, removeUser),
    takeLatest(PasswordTypes.UPDATE_PASSWORD_REQUEST, updatePassword),
    takeLatest(UserTypes.GET_ACCOUNT_REQUEST, getAccount),
    takeLatest(CartTypes.CALCULATE_AMOUNT, reorganizeBasket),
    takeLatest(CartTypes.REMOVE_PRODUCTS_CART, removeProductsFromCart),
    takeLatest(AddressTypes.GET_ADDRESSES_REQUEST, getAddresses),
    takeLatest(BannersTypes.GET_BANNER_PRODUCTS_REQUEST, getBannersProducts),
    takeLatest(
      StoreByUserTypes.CHECK_ITEMS_OUT_OF_STOCK,
      checkOutOfStockProductsByStore
    ),
    takeLatest(
      StoreByUserTypes.DELETE_OUT_OF_STOCK_ITEMS,
      deleteOutOfStockItemsFromCart
    ),
    takeLatest(OrderTypes.CONFIRM_ORDER_REQUEST, finishOrder),
    takeLatest(DomainTypes.GET_DOMAIN_REQUEST, getStoreByDomain),
    takeLatest(OrderTypes.ORDER_REQUEST_PIX_PAYMENT, createPixPayment),
    takeLatest(CouponTypes.GET_COUPON_REQUEST, getCoupon),
    takeLatest(CategoryTypes.GET_REQUEST, getCategories),
    takeLatest(CartTypes.SYNC_CART_STATE, syncCartState),
    // SIGN_IN_FAILURE NÃO dispara `signOut`: o saga apaga `@ConexaoGAM:cart` e
    // qualquer falha de login/cadastro (senha errada, e-mail duplicado, timeout)
    // destruía a cesta do convidado em silêncio. Não há sessão a limpar aqui —
    // a API responde 400 antes de emitir os cookies (SessionController.store).
    takeLatest(AuthTypes.SIGN_IN_SUCCESS, signInSuccess),
    call(analyticsSaga),
    takeLatest(IdentidadeVisualTypes.FETCH_IDENTIDADE_VISUAL_REQUEST, fetchIdentidadeVisual),

    // Contexto de entrega.
    // A gravacao de @ConexaoGAM:selectedStore e o window.location.reload(false) saem do
    // reducer de storeByUser e passam a viver aqui.
    takeEvery(StoreByUserTypes.SET_SELECTED_STORE, persistSelectedStore),
    takeLatest(DeliveryContextTypes.HYDRATE, hydrateDeliveryContext),
    takeLatest(
      [DeliveryContextTypes.APPLY_CEP, DeliveryContextTypes.SELECT_ADDRESS],
      applyLocation
    ),
    takeLatest(DeliveryContextTypes.RESOLVE_REQUEST, resolveCoverage),
    takeLatest(DeliveryContextTypes.SET_LOCKED_PHARMACY, onLockedPharmacyChanged),
    takeLatest(DeliveryContextTypes.ADDRESS_REMOVED, onAddressRemoved),
    // Herda o endereco inicial no login e no boot com sessao ativa: SIGN_IN_SUCCESS e
    // despachado pelos dois caminhos. A regra de precedencia torna o boot inocuo quando ja
    // ha contexto.
    takeLatest(AuthTypes.SIGN_IN_SUCCESS, inheritInitialAddress),
    fork(watchStorageSync),
    fork(watchAddressUpdate)
  ]);
}
